var map = {
	"./": 46,
	"./academy": 195,
	"./academy-dev": 196,
	"./academy-dev.js": 196,
	"./academy-local": 197,
	"./academy-local.js": 197,
	"./academy-preprod": 198,
	"./academy-preprod.js": 198,
	"./academy.js": 195,
	"./dev": 199,
	"./dev-v2": 200,
	"./dev-v2.js": 200,
	"./dev.js": 199,
	"./index": 46,
	"./index.js": 46,
	"./local": 201,
	"./local.js": 201,
	"./preprod": 202,
	"./preprod.js": 202,
	"./prod": 203,
	"./prod.js": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;